import dynamic from 'next/dynamic';
import { HeroProps } from './types';

export const heroVariantMap: Record<
  HeroProps['variant'],
  React.ComponentType<any>
> = {
  splitImage: dynamic(() => import('./variants/SplitImageHero')),
  stackedMedia: dynamic(() => import('./variants/StackedMediaHero')),
  overlaySlider: dynamic(() => import('./variants/OverlaySliderHero')),
  overlayMinimal: dynamic(() => import('./variants/OverlayMinimalHero')),
};
